import {ErrorMessageProps, ErrorsMessage, ErrorsType} from './ErrorsType';
import React from 'react';
import {MessageDialog} from '../MessageDialog/MessageDialog';

export const ForbiddenMessage: React.FC<ErrorMessageProps> = ({open, onClose}) => {
  return (
    <MessageDialog title={'Informasjon'}width={700} height={300}  open={open} onClose={onClose}>
      <div style={{minWidth: '34rem'}}>
        <span>{ErrorsMessage[ErrorsType.Forbidden]}</span>
      </div>
    </MessageDialog>
  );
};
